import type { OtherPickerEntry } from '../../../utils/electronicsDashboardUtils';
import { useChoosePortsToolbar } from './useChoosePortsToolbar';

/** Header toolbar for multi-port other-electronics stream widgets (`other`). */
export function useChooseOtherElectronicsToolbar({
  show,
  isHistoricMode,
  adapters,
  selectedPorts,
  onSelectedPortsChange,
  disabled,
  selectedPortsKey,
}: {
  show: boolean;
  isHistoricMode: boolean;
  adapters: readonly OtherPickerEntry[];
  selectedPorts: readonly number[];
  onSelectedPortsChange: (ports: number[]) => void;
  disabled?: boolean;
  selectedPortsKey: string;
}) {
  return useChoosePortsToolbar({
    show,
    isHistoricMode,
    entries: adapters,
    selectedPorts,
    onSelectedPortsChange,
    disabled,
    selectedPortsKey,
    chooseButtonI18nKey: 'dashboard.otherWidget.chooseAdapters',
    chooseButtonDefault: 'Choose Adapters',
    chooseAllI18nKey: 'dashboard.otherWidget.chooseAll',
    chooseAllDefault: 'Choose all',
  });
}
